import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../../styles/pages.css";
import bg1 from "../../assets/images/bg1.png";
import bg2 from "../../assets/images/bg2.png";
import bg3 from "../../assets/images/bg3.png";
import logo from "../../assets/images/logo1.png";
import arrow from "../../assets/images/arrow.png";
import newsImage from "../../assets/images/newthumb.png";
import { getListMainNotice, getPopup } from "../../api";

const ImagePopup = ({ imageUrl, linkUrl, onClose, offset }) => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // 쿠키 확인하여 팝업 표시 여부 결정
    const checkCookie = () => {
      const popupHidden = document.cookie.split("; ").find((row) => row.startsWith("popupHidden="));

      if (!popupHidden) {
        setIsVisible(true);
      }
    };

    checkCookie();
  }, []);

  // 팝업 닫기
  const closePopup = () => {
    setIsVisible(false);
    onClose && onClose();
  };

  // 1일간 보지 않기
  const hidePopupForDay = () => {
    const date = new Date();
    date.setTime(date.getTime() + 24 * 60 * 60 * 1000); // 1일 후
    document.cookie = `popupHidden=true; expires=${date.toUTCString()}; path=/`;
    closePopup();
  };

  if (!isVisible) return null;
  return (
    <div className="popup-container" style={{ left: `${offset}px` }}>
      <div className="popup-buttons">
        <button onClick={hidePopupForDay} className="popup-button">
          Don't show for 1 day
        </button>
        <button onClick={closePopup} className="popup-button">
          Close
        </button>
      </div>
      <div className="popup-content">
        <a href={linkUrl} target="_blank" rel="noopener noreferrer">
          <img src={imageUrl} alt="popup image" className="popup-image" />
        </a>
      </div>
    </div>
  );
};
const EnHome = () => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  // const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [card_notices, setCardNotices] = useState([]);
  const [list_notices, setListNotices] = useState([]);
  const [popups, setPopups] = useState([]);
  // const [showPopup, setShowPopup] = useState(true);
  const [visiblePopups, setVisiblePopups] = useState({});
  const [currentPopupIndex, setCurrentPopupIndex] = useState(0);
  const isMobile = window.innerWidth <= 768;

  const slides = [
    {
      image: bg1,
      title: "The future of the greenhouse\n in the facility is ECOTECH GLOBAL will open",
      subtitle: "It will be an eco-farm that runs and runs to increase the income of Lunar New Year farmers and to promote the convenience of greenhouse management",
    },
    {
      image: bg2,
      title: "The future of the greenhouse\n in the facility is ECOTECH GLOBAL will open",
      subtitle: "It will be an eco-farm that runs and runs to increase the income of Lunar New Year farmers and to promote the convenience of greenhouse management",
    },
    {
      image: bg3,
      title: "The future of the greenhouse\n in the facility is ECOTECH GLOBAL will open",
      subtitle: "It will be an eco-farm that runs and runs to increase the income of Lunar New Year farmers and to promote the convenience of greenhouse management",
    },
  ];
  useEffect(() => {
    (async () => {
      const res = await getListMainNotice();
      const data = res.data;
      setCardNotices(data.card_notices);
      setListNotices(data.list_notices);

      const resp = await getPopup();
      const popupList = resp.data.results;
      setPopups(popupList);

      const initialVisible = {};
      popupList.forEach((p) => {
        initialVisible[p.id] = true;
      });
      setVisiblePopups(initialVisible);
    })();
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const handleNewsClick = (link) => {
    if (link) {
      window.open(link, "_blank", "noopener,noreferrer");
    }
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const closeOnePopup = (id) => {
    setVisiblePopups((prev) => ({ ...prev, [id]: false }));
  };

  return (
    <>
      {popups.length > 0 && (
        <div className="popup-overlay">
          {isMobile ? (
            // mobile
            popups[currentPopupIndex] &&
            visiblePopups[popups[currentPopupIndex].id] ? (
              <ImagePopup
                key={popups[currentPopupIndex].id}
                imageUrl={popups[currentPopupIndex].image_url}
                linkUrl={popups[currentPopupIndex].link_url}
                onClose={() => {
                  closeOnePopup(popups[currentPopupIndex].id);
                  setCurrentPopupIndex((prev) => prev + 1);
                }}
              />
            ) : null
          ) : (
            popups.map((popup, index) =>
              visiblePopups[popup.id] ? (
                <ImagePopup
                  key={popup.id}
                  imageUrl={popup.image_url}
                  linkUrl={popup.link_url}
                  offset={index * 40}
                  onClose={() => closeOnePopup(popup.id)}
                />
              ) : null
            )
          )}
        </div>
      )}
      <div className="main">
        <div className="slider-container">
          {slides.map((slide, index) => (
            <div key={index} className={`slide ${index === currentSlide ? "active" : ""}`} style={{ backgroundImage: `url(${slide.image})` }}>
              <div className="mainSection-1 mainSection-1-en">
                <p>
                  {slide.title.split("\n").map((line, i) => (
                    <React.Fragment key={i}>
                      {line}
                      {i < slide.title.split("\n").length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </p>
                <p>{slide.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="slider-indicators">
          {slides.map((_, index) => (
            <button key={index} className={`indicator ${index === currentSlide ? "active" : ""}`} onClick={() => goToSlide(index)} />
          ))}
        </div>
      </div>
      <div className="mainSectionbg-2">
        <div className="container">
          {/* 에코텍글로벌 소개 섹션 */}
          <div className="intro-section">
            <div className="logo-container">
              <img src={logo} alt="ECOFARM" className="ecofarm-logo" />
            </div>
            <h2 className="intro-title">ECOTECH GLOBAL creates agricultural infrastructure</h2>
            <p className="intro-subtitle intro-subtitle-en">
              It will be an eco-farm that runs and runs to increase the income of Lunar New Year farmers and to promote the convenience of greenhouse management
            </p>
            <div className="intro-content intro-content-en">
              <p>Eco-farm starts from the voice of the field.</p>
              <p>
                A study on customized construction methods tailored to the size of greenhouses, climate, and crop characteristics in Korea <br /> We trained more than 200 professional engineers
                ourselves and deployed them across the country.
              </p>
              <p>
                With a "run and run" position, increase farm household income
                <br />
                We will continue innovation for convenient greenhouse management.
              </p>
            </div>
            <Link to="/en/about/greeting" className="more-btn" onClick={scrollToTop}>
              more <img src={arrow} alt="more" className="arrow" />
            </Link>
          </div>
          {/* Products 섹션 */}
          <div className="products-section">
            <h3 className="products-title">products</h3>
            <div className="products-grid">
              <div className="product-card">
                <div className="product-content ">
                  <div className="product-content-row">
                    <h4>Greenhouse construction</h4>
                    <p>
                      It uses high heat and high durability materials <br /> Reduce energy costs and maximize crop productivity.
                    </p>
                  </div>
                  <Link to="/en/products/construction" className="product-btn" onClick={scrollToTop}>
                    more <img src={arrow} alt="more" className="arrow" />
                  </Link>
                </div>
              </div>
              <div className="product-card">
                <div className="product-content">
                  <div className="product-content-row">
                    <h4>
                      a shading/ <br />
                      cleaning agent
                    </h4>
                    <p>
                      Reduce work time and minimize maintenance costs
                      <br /> by using both spraying and cleaning.
                    </p>
                  </div>
                  <Link to="/en/products/sanitizer" className="product-btn" onClick={scrollToTop}>
                    more <img src={arrow} alt="more" className="arrow" />
                  </Link>
                </div>
              </div>
              <div className="product-card">
                <div className="product-content">
                  <div className="product-content-row">
                    <h4>crop crushing</h4>
                    <p>
                      After harvesting, shred the residue into ultra-fine pieces <br /> Accelerate composting and reduce by-product treatment costs.
                    </p>
                  </div>
                  <Link to="/en/products/shredder" className="product-btn" onClick={scrollToTop}>
                    more <img src={arrow} alt="more" className="arrow" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* News 섹션 */}
      <div className="news-section">
        <div className="container">
          <h3 className="news-title">news</h3>
          <div className="news-grid">
            <div className="news-featured">
              {card_notices.map((notice, index) => (
                <div className="news-card large" onClick={() => handleNewsClick(notice.link)}>
                  <div className="news-image">
                    <img src={newsImage} alt="Ecofarm News" />
                  </div>
                  <div className="news-content">
                    <p className="news-text">{notice.en_translations[0]?.title_en || notice.title}</p>
                    <p className="news-date">{new Date(notice.created_at).toISOString().split("T")[0]}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="news-list">
              {list_notices.map((notice, index) => (
                <div key={index} className="news-item" onClick={() => handleNewsClick(notice.link)}>
                  <p className="news-text">{notice.en_translations[0]?.title_en || notice.title}</p>
                  <p className="news-date">{new Date(notice.created_at).toISOString().split("T")[0]}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EnHome;
